/**
 * Work backwards from the current usage sum to the calculate the usage sums at each of
 * the usage events (use for team members, storage, custom styles, and custom tilesets,
 * where usage events are stored as how much the value has changed by - i.e. deltas -
 * and can be negative).
 */
export const resolveUsageEventDeltas = (
  usageEvents: [number, number][],
  usageSum: number,
): [number, number][] => {
  const n = usageEvents.length;
  if (n < 1) return [];

  const resolved = new Array(n).fill(null);
  let currentSum = usageSum;

  for (let i = n - 1; i > -1; i--) {
    let delta = 0;
    if (i < n - 1) {
      delta = Number(usageEvents[i + 1]?.[1]);
    }
    currentSum = currentSum - delta;

    resolved[i] = [usageEvents[i]?.[0], currentSum];
  }

  return resolved as [number, number][];
};
